import * as types from "./types";

export const setQuestionnaire = questionnaireId => {
  return {
    type: types.SET_QUESTIONNAIRE,
    payload: questionnaireId,
  };
};

export const setSurveyStatus = status => {
  return {
    type: types.SET_SURVEY_STATUS,
    payload: status,
  };
};

export const setStartTime = time => {
  return {
    type: types.SET_START_TIME,
    payload: time,
  };
};

export const setSurveyMessage = message => {
  return {
    type: types.SET_SURVEY_MESSAGE,
    payload: message,
  };
};

export const setInviteId = id => {
  return {
    type: types.SET_INVITE_ID,
    payload: id,
  };
};

export const setPreventInviteId = id => {
  return {
    type: types.SET_PREVENT_ID,
    payload: id,
  };
};

export const setForGo = flag => {
  return {
    type: types.SET_FOR_GO,
    payload: flag,
  };
};

export const setSurveyScore = score => {
  return {
    type: types.SET_SURVEY_SCORE,
    payload: score,
  };
};

export const setPreviousResponse = previousResponse => {
  return {
    type: types.SET_PREVIOUS_RESPONSE,
    payload: previousResponse,
  };
};

export const storeItems = items => {
  return {
    type: types.STORE_ITEMS,
    payload: items,
  };
};

export const hideItemList = () => {
  return {
    type: types.HIDE_ITEM_LIST,
  };
};

export const removeLinkedOption = () => {
  return {
    type: types.REMOVE_LINKED_OPTION,
  };
};

export const setLinkedOptionForItem = (questionId, optionId, subOptionId) => {
  return {
    type: types.SET_LINKED_OPTION_FOR_ITEM,
    payload: { questionId, optionId, subOptionId },
  };
};

export const setQuizFlag = () => {
  return {
    type: types.SET_QUIZ_FLAG,
  };
};

export const setQuizScore = (quizTotal, quizScore) => {
  return {
    type: types.SET_QUIZ_SCORE,
    payload: { quizTotal, quizScore },
  };
};

export const setDivisionInfo = divisionInfo => {
  return {
    type: types.SET_DIVISION_INFO,
    payload: divisionInfo,
  };
};

export const setIsDemo = isDemo => {
  return {
    type: types.SET_IS_DEMO,
    payload: isDemo,
  };
};

export const setIsAppEmbed = isAppEmbed => {
  return {
    type: types.SET_IS_APP_EMBED,
    payload: isAppEmbed,
  };
};

export const setAutoStart = flag => {
  return {
    type: types.SET_AUTO_START,
    payload: flag,
  };
};

export const setStageNumber = stage => {
  return {
    type: types.SET_STAGE_NUMBER,
    payload: stage,
  };
};

export const setLastFeedbackId = id => {
  return {
    type: types.SET_LAST_FEEDBACK_ID,
    payload: id,
  };
};

export const setPreviousStagesResponse = response => {
  return {
    type: types.SET_PREVIOUS_STAGES_RESPONSE,
    payload: response,
  };
};

export const setSurveyFields = fields => {
  return {
    type: types.SET_SURVEY_FIELDS,
    payload: fields,
  };
};

export const setSubmittedBy = userID => {
  return {
    type: types.SET_SUBMITTED_BY,
    payload: userID,
  };
};
